import { request, type DataInfoResponse, type PagedList } from './request';
import { buildListParams } from './params';
import type { ActivityDto } from './types';

export interface ActivityListOptions {
  pageIndex?: number;
  pageSize?: number;
  /** 名称搜索 */
  name?: string;
  /** 活动类型（0-全部） */
  activityType?: number;
  /** 活动状态（0-全部） */
  activityState?: number;
}

/** 活动列表（/activity/userGetActivityList，公开接口） */
export function fetchActivityList(options: ActivityListOptions = {}): Promise<PagedList<ActivityDto>> {
  const { pageIndex = 1, pageSize = 10, name = '', activityType = 0, activityState = 0 } = options;

  return request(
    '/activity/userGetActivityList',
    buildListParams({
      pageIndex,
      pageSize,
      state: 1,
      name,
      extra: {
        userId: 0,
        doctorId: 0,
        activityType,
        activityState,
        activityStartTime: '',
        activityEndTime: '',
        signStartTime: '',
        signEndTime: '',
        isSign: 0,
      },
    }),
  );
}

/** 活动详情（/activity/userGetActivityInfo，公开接口） */
export function fetchActivityInfo(id: number): Promise<DataInfoResponse<ActivityDto>> {
  return request('/activity/userGetActivityInfo', { id });
}

/** 报名/支付状态响应（userSignActivity 与 getSignPayState 共用） */
export interface SignActivityResponse {
  /** 报名单 Id（支付状态轮询 / 手动刷新使用；支付在小程序内完成） */
  signId: number;
  activityId: number;
  /** 是否需要支付（收费活动且未完成支付） */
  needPay: boolean;
  /** 报名费（元） */
  signFee: number;
  /** 支付状态：0-无需支付 1-待支付 2-已支付 3-已退款 */
  payState: number;
  /** 支付状态描述 */
  payStateStr: string;
  /** 提示信息 */
  message: string;
}

/** 活动报名（/activity/userSignActivity，需登录；重复报名返回现有报名单，幂等） */
export function signActivity(id: number, remark = ''): Promise<SignActivityResponse> {
  return request('/activity/userSignActivity', { id, remark });
}

/** 查询报名支付状态（/activity/getSignPayState，支付弹窗轮询与手动刷新；支付在小程序内完成） */
export function getSignPayState(signId: number): Promise<SignActivityResponse> {
  return request('/activity/getSignPayState', { signId });
}
